
import { defineComponent, SetupContext, ref, computed } from "vue";
import NativeClient from "@/client/native-client";
import {DETAIL_ITEM_TITLE} from "@/types/pantry";

export default defineComponent({
  name: "PantryValueDialog",
  components: {
  },
  props: {
    value: {
      type: Number,
      default: 0,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    NativeClient.sendDebugLog("PantryValueDialog onClickSetting props.value=" + props.value);
    const selectValue = ref("");
    const valueList = ref(Array<string>());
    const init = () => {
      for (let i = 0; i <= 100; i += 10) {
        const item = "" + i + "%";
        valueList.value.push(item);
      }
    };
    init();
    const getValueList = () => {
      return valueList.value;
    };
    const updateValue = computed(() => {
      NativeClient.sendDebugLog("PantryStockNotificationValueDialog updateTime value=" + JSON.stringify(props.value));
      selectValue.value = "" + props.value + "%";
    });
    const onClickSetting = () => {
      let i = 0;
      let select = 0;
      valueList.value.forEach(item => {
        if (item == selectValue.value) {
          select = i;
          return;
        }
        i++;
      });
      select *= 10;
      NativeClient.sendDebugLog("PantryValueDialog onClickSetting selectValue=" + select);
      context.emit("click-setting", select);
    };
    const onClickClose = () => {
      context.emit("click-close");
    };
    return {
      selectValue,
      getValueList,
      onClickSetting,
      onClickClose,
      updateValue,
      DETAIL_ITEM_TITLE
    };
  }
});
